(function() {
  if (window.HugfigProductExtras) {
    window.HugfigProductExtras.initAll();
    return;
  }

  function initBundle(container) {
    if (!container || container.dataset.hugfigBundleInitialized === 'true') return;

    const checkboxes = Array.from(container.querySelectorAll('.hugfig-gift-ready-bundle__checkbox'));
    const summaryCount = container.querySelector('[data-bundle-count]');
    const summaryDetail = container.querySelector('[data-bundle-detail]');
    if (!summaryCount || !summaryDetail) return;

    const controller = new AbortController();
    const listenerOptions = { signal: controller.signal };

    function updateSummary() {
      let checkedCount = 0;
      let freeCount = 0;
      let totalSavingsInCents = 0;

      checkboxes.forEach(function(checkbox) {
        if (!checkbox.checked) return;

        checkedCount += 1;
        if (checkbox.dataset.isFree === 'true') {
          freeCount += 1;
          return;
        }

        const price = Number.parseInt(checkbox.dataset.price, 10) || 0;
        const comparePrice = Number.parseInt(checkbox.dataset.comparePrice, 10) || price;
        totalSavingsInCents += Math.max(comparePrice - price, 0);
      });

      summaryCount.textContent = String(checkedCount);
      summaryDetail.textContent = totalSavingsInCents > 0
        ? 'Save $' + (totalSavingsInCents / 100).toFixed(2)
        : freeCount > 0
          ? 'Included ' + freeCount + ' free'
          : 'No free gifts selected';
      document.dispatchEvent(new CustomEvent('hugfig:addons-change'));
    }

    checkboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', updateSummary, listenerOptions);
    });

    container.dataset.hugfigBundleInitialized = 'true';
    container.hugfigBundleController = controller;
    updateSummary();
  }

  function initDrawer(drawer) {
    if (!drawer || drawer.dataset.hugfigDrawerInitialized === 'true') return;

    const section = drawer.closest('.shopify-section') || document;
    const overlay = drawer.querySelector('.hugfig-accessory-drawer__overlay');
    const panel = drawer.querySelector('.hugfig-accessory-drawer__content');
    const closeButton = drawer.querySelector('.hugfig-accessory-drawer__close');
    const returnButton = drawer.querySelector('.hugfig-accessory-drawer__return-btn');
    const drawerImage = drawer.querySelector('#HugfigAccessoryDrawerImage');
    const drawerTitle = drawer.querySelector('#HugfigAccessoryDrawerTitle');
    const drawerPrice = drawer.querySelector('#HugfigAccessoryDrawerPrice');
    const drawerCompare = drawer.querySelector('#HugfigAccessoryDrawerComparePrice');
    const drawerDescription = drawer.querySelector('#HugfigAccessoryDrawerDescription');
    if (!overlay || !panel || !closeButton || !returnButton) return;

    const controller = new AbortController();
    const listenerOptions = { signal: controller.signal };
    let triggerElement = null;

    function closeDrawer(options) {
      const restoreFocus = !options || options.restoreFocus !== false;
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');

      if (restoreFocus && triggerElement && document.contains(triggerElement)) {
        triggerElement.focus();
      }
      triggerElement = null;
    }

    function openDrawer(trigger, source) {
      triggerElement = trigger;
      drawerTitle.textContent = source.dataset.title || '';
      drawerPrice.textContent = source.dataset.price || '';
      drawerDescription.innerHTML = source.dataset.description || '';

      if (source.dataset.image) {
        drawerImage.src = source.dataset.image;
      } else {
        drawerImage.removeAttribute('src');
      }
      drawerImage.alt = source.dataset.title || '';

      drawerCompare.textContent = source.dataset.comparePrice || '';
      drawerCompare.hidden = !source.dataset.comparePrice;

      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
      closeButton.focus();
    }

    section.addEventListener('click', function(event) {
      const trigger = event.target.closest('.hugfig-trigger-drawer');
      if (!trigger || !section.contains(trigger)) return;

      const source = trigger.closest('.hugfig-gift-ready-bundle__item') || trigger;
      openDrawer(trigger, source);
    }, listenerOptions);

    overlay.addEventListener('click', function() {
      closeDrawer();
    }, listenerOptions);
    closeButton.addEventListener('click', function() {
      closeDrawer();
    }, listenerOptions);
    returnButton.addEventListener('click', function() {
      closeDrawer();
    }, listenerOptions);

    document.addEventListener('keydown', function(event) {
      if (!drawer.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = Array.from(panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }, listenerOptions);

    controller.signal.addEventListener('abort', function() {
      closeDrawer({ restoreFocus: false });
    }, { once: true });

    drawer.dataset.hugfigDrawerInitialized = 'true';
    drawer.hugfigDrawerController = controller;
  }

  function initAll(scope) {
    const root = scope || document;
    root.querySelectorAll('.hugfig-gift-ready-bundle').forEach(initBundle);
    root.querySelectorAll('.hugfig-accessory-drawer').forEach(initDrawer);
  }

  function destroyAll(scope) {
    const root = scope || document;

    root.querySelectorAll('.hugfig-gift-ready-bundle').forEach(function(container) {
      if (container.hugfigBundleController) container.hugfigBundleController.abort();
      delete container.hugfigBundleController;
      delete container.dataset.hugfigBundleInitialized;
    });

    root.querySelectorAll('.hugfig-accessory-drawer').forEach(function(drawer) {
      if (drawer.hugfigDrawerController) drawer.hugfigDrawerController.abort();
      delete drawer.hugfigDrawerController;
      delete drawer.dataset.hugfigDrawerInitialized;
    });
  }

  window.HugfigProductExtras = { initAll, destroyAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function(event) {
    destroyAll(event.target);
  });
})();
